const ImageHover = {
    init: function () {
        ImageHover.setupVisibleImages();
        
        if (deviceIsMobile.matches) {
            ImageHover.bindMobileEvents();
        } else {
            ImageHover.bindEvents();
        }

        ImageHover.setupLazyLoad();
    },

    reinit: function () {
        ImageHover.setupNewImages();
        
        if (deviceIsMobile.matches) {
            ImageHover.bindMobileEventsToNew();
        } else {
            ImageHover.bindEventsToNew();
        }
    },

    setupVisibleImages: function () {
        $('.collection-container .product-card-canvas:visible, .search-bar-item .product-card-canvas:visible').each(function () {
            ImageHover.setupSingleImage($(this));
        });
    },

    setupNewImages: function () {
        $('.collection-container .product-card-canvas:not(.initialized), .search-bar-item .product-card-canvas:not(.initialized)').each(function () {
            ImageHover.setupSingleImage($(this));
        });
    },

    setupSingleImage: function ($image) {
        $image.find('.product-card-image:eq(0)').addClass('image-active');
        $image.addClass('initialized');
    },

    setupLazyLoad: function () {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    ImageHover.setupSingleImage($(entry.target));
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '100px' });

        $('.collection-container .product-card-canvas:not(.initialized), .search-bar-item .product-card-canvas:not(.initialized)').each(function () {
            observer.observe(this);
        });
    },

    bindEvents: function () {
        $('main .plp-product-standard .card-active:not(.plp-auto-hover):not(.view-all-product):not(.event-bound)').each(function () {
            var hovered = $(this);
            var cycle;
            var timer;
            hovered.hover(
                function () {
                    hovered.addClass('hovering-card');
                    var thumbnailIndex = 0;
                    var thumbnailArray = hovered
                        .find('.media')
                        .children()
                        .not('.product-image-color-overlay');

                    timer = setTimeout(function () {
                        thumbnailIndex++;
                        var $visible = thumbnailArray.eq(thumbnailIndex);
                        thumbnailArray.removeClass('image-active');
                        $visible.addClass('image-active');
                        cycle = setInterval(function () {
                            thumbnailIndex++;
                            if (thumbnailIndex === thumbnailArray.length) {
                                thumbnailIndex = 0;
                            }
                            thumbnailArray.removeClass('image-active');
                            thumbnailArray.eq(thumbnailIndex).addClass('image-active');
                        }, 1800);
                    }, 1300);

                    hovered.data('timer', timer);
                    hovered.data('cycle', cycle);
                },
                function () {
                    ImageHover.resetCycle(hovered);
                    clearTimeout(timer);
                    clearInterval(cycle);
                }
            );
            $(this).addClass('event-bound');
        });
    },

    bindEventsToNew: function () {
        $('main .plp-product-standard .card-active:not(.plp-auto-hover):not(.view-all-product):not(.event-bound)').each(function () {
            ImageHover.bindEvents();
        });
    },

    bindMobileEvents: function () {
        $('.plp--atb.krw--mobile-only .plp--atb-trigger-main:not(.event-bound)').on('click', function () {
            var $productCard = $(this).closest('.plp-product-standard .card-active');
            ImageHover.stopAllCycles();
            ImageHover.startCycle($productCard);
            $(this).addClass('event-bound');
        });

        $('.addToCart').on('click', function () {
            var $card = $('.hovering-card');
            ImageHover.resetCycle($card);
        });

        $(window).on('scroll', ImageHover.debounce(function () {
            ImageHover.handleScroll();
        }, 250));

        $('main #product-grid').on('scroll', ImageHover.debounce(function () {
            ImageHover.handleScroll();
        }, 250));
    },

    bindMobileEventsToNew: function () {
        $('.plp--atb.krw--mobile-only .plp--atb-trigger-main:not(.event-bound)').each(function () {
            ImageHover.bindMobileEvents();
        });
    },

    handleScroll: function () {
        var $card = $('.hovering-card');
        ImageHover.resetCycle($card);
    },

    startCycle: function (card) {
        var thumbnailIndex = 0;
        var thumbnailArray = card.find('.media').children().not('.product-image-color-overlay');

        card.addClass('hovering-card');

        var cycleNextImage = function() {
            thumbnailIndex++;
            if (thumbnailIndex >= thumbnailArray.length) {
                thumbnailIndex = 0;
            }

            var $nextImage = thumbnailArray.eq(thumbnailIndex);
            ImageHover.ensureImageLoaded($nextImage).then(() => {
                thumbnailArray.removeClass('image-active');
                $nextImage.addClass('image-active');
                card.data('cycle', setTimeout(cycleNextImage, 1800));
            });
        };

        card.data('timer', setTimeout(cycleNextImage, 1300));
    },

    ensureImageLoaded: function($img) {
        return new Promise((resolve) => {
            if ($img.hasClass('image-is-loaded')) {
                resolve();
            } else {
                $img.attr('loading', 'eager');
                if ($img[0].complete) {
                    $img.addClass('image-is-loaded');
                    resolve();
                } else {
                    const loadHandler = function() {
                        $img.addClass('image-is-loaded');
                        resolve();
                    };
                    $img.on('load', loadHandler);
                    
                    // Add fallback timer
                    setTimeout(() => {
                        if (!$img.hasClass('image-is-loaded')) {
                            console.warn('Image load timed out:', $img.attr('src'));
                            $img.off('load', loadHandler);
                            resolve();
                        }
                    }, ImageHover.loadTimeout);
                }
            }
        });
    },

    loadTimeout: 3000, 

    stopAllCycles: function () {
        $('.plp-product-standard .card-active.hovering-card').each(function () {
            ImageHover.resetCycle($(this));
        });
    },

    resetCycle: function (card) {
        var thumbnailArray = card.find('.media').children().not('.product-image-color-overlay');
        thumbnailArray.removeClass('image-active');
        thumbnailArray.eq(0).addClass('image-active');
        card.removeClass('hovering-card');

        clearTimeout(card.data('timer'));
        clearTimeout(card.data('cycle'));
    },

    debounce: function (func, wait) {
        var timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    }
};

ImageHover.init();

$(document).on('click', '.plp--atb-trigger:not(.js-product-add-to-cart-plp):not(.plp-final-sale-options-trigger):not(.item-in-cart)', function(){
    var $this = $(this);
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-options');
    $this.parents('.plp-product-grid-item').addClass('plp-atb-showing');
    $this.parents('.card-wrapper').addClass('card-showing-atb');
    $this.parents('.card-wrapper').addClass('hovering-card');
    $this.parents('.collection-grid-product-item').addClass('plp-atb--active');
});

$(document).on('click', '.plp-final-sale-options-trigger:not(.item-in-cart)', function(){
    var $this = $(this);
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-final-sale-options');
});

window.addEventListener('scroll', function(){
    $('.plp-atb--buttons').removeClass('plp-atb--show-options');
    $('.card-showing-atb').removeClass('card-showing-atb');
    $('.plp-atb-showing').removeClass('plp-atb-showing');
}, true);

$(document).mouseup(function (e) {
    var container = $(".plp-atb--active");
    if(!container.is(e.target) && container.has(e.target).length === 0) {
        $('.card-showing-atb .plp-atb--buttons').removeClass('plp-atb--show-options');
        $('.card-showing-atb').removeClass('card-showing-atb');
        $('.plp-atb-showing').removeClass('plp-atb-showing'); 
    }
});

$(document).on('click', 'button.btn.btn-solid.plp-trigger-inner-options', function(){
    var $this = $(this);
    $this.parents('.plp-atb--buttons').find('.plp-atb--buttons-inner').addClass('plp-atb--show--inner-options');
    $this.parents('.plp-atb--buttons').addClass('plp-atb--show--inner-options-final-sale');
    $('body').addClass('body-plp-atb--show--inner-options');
});